import { TipsMapType } from '@op/components/BubbleCommon';
import React from 'react';

export const videoHeaderTipsMap: TipsMapType = {
  en: (
    <>
      Use filters to explore video rankings by country and category. <br />
      Data sources: TikTok, YouTube platforms <br />
      Update frequency: Twice daily (morning and evening), with same-day data
      availability (T+0)
    </>
  ),
  zh: (
    <>
      支持筛选查看指定国家及品类下的视频榜单。 <br />
      数据来源：TikTok、Youtube平台 <br />
      更新频率：每日早晚各一次，数据当日更新（T+0）
    </>
  ),
};


export const videoDouyinViewsTipsMap: TipsMapType = {
  en: 'Unable to retrieve the view count for the Douyin video due to platform limitations.',
  zh: '因平台本身限制没办法获取抖音视频的播放量',
};